import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { WarehouseTransfer } from 'src/app/assabil-sales/models/entities/warehouse-transfer';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { WarehouseTransferRequest } from 'src/app/assabil-sales/models/entities/warehouse-transfer-request';
import { SdeliveryNote } from 'src/app/assabil-sales/models/entities/s-delivery-note';
import { SdeliveryNoteLine } from 'src/app/assabil-sales/models/entities/s-delivery-note-line';
import { BasicItem } from 'src/app/tools/models/dtos/basic-item';
import { WarehouseTransferPipe } from 'src/app/assabil-sales/pipes/warehouse-transfer-pipe';
import { WarehouseTransferLine } from 'src/app/assabil-sales/models/entities/warehouse-transfer-line';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { Field } from 'src/app/tools/models/dtos/field';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { ConfigService } from 'src/app/tools/services/config.service';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';



@Component({
    selector: 'warehouse-transfer-widget',
    templateUrl: './warehouse-transfer-widget.component.html',
    styleUrls: ['./warehouse-transfer-widget.component.scss']
})


export class WarehouseTransferWidgetComponent extends BaseWidget  {

  @Input() purchasePacking : boolean = false;

  warehouseTransferPipe         : WarehouseTransferPipe = new WarehouseTransferPipe();

  warehouseTransfer             : WarehouseTransfer = new WarehouseTransfer();
  WarehouseTransferLineColumns  = [];
  enteredOnly                   : boolean = true;
  warehousesManaged             : BasicItem[] = null;
  entryMode                     : boolean = false;
  //context                       : string  = null;
  
  /*
  {'label' : 'Retour Demandé',           readOnly : false, background :'#eef5fb'},  
  {'label' : 'Retour Endommagé Demandé', readOnly : false, background :'#faeeee'}, 
  {'label' : 'Retour Périmé Demandé',    readOnly : false, background :'#f0dede'}, 
*/

 qcRequestedQuantity                    = {label : 'Qté demandée',              writeOnly : false, readOnly : true,                    background :'#eef5fb'};
 qcConfirmedQuantity                    = {label : 'Qté confirmée',             writeOnly : false, readOnly : false,                   background :'#eef5fb'};
 

 qcAssignedQuantity                     = {label : 'Qté affectée',              writeOnly : false, readOnly : true,                   background :'#eef5fb'};
 qcToBeAssignedQuantity                 = {label : 'Qté A affecter',            writeOnly : true,  readOnly : false,                  background :'#eef5fb'};

 qcAvailableQuantity                    = {label : 'stock résiduel',            writeOnly : false, readOnly : true,                   background :'#eef5fb'};
 qcConfirmedReturnedQuantity            = {label : 'Retour Demandé',            writeOnly : false, readOnly : false,                  background :'#eef5fb'};
 qcConfirmedReturnedDamagedQuantity1    = {label : 'Retour Endommagé Demandé',  writeOnly : false, readOnly : false,                  background :'#faeeee'};
 qcConfirmedReturnedDamagedQuantity2    = {label : 'Retour Périmé Demandé',     writeOnly : false, readOnly : false,                  background :'#f0dede'};
 
 qcAssignedReturnedQuantity             = {label : 'Retour Accepté',            writeOnly : false, readOnly : true, hidden : false,   background :'#eef5fb'};
 qcAssignedReturnedDamagedQuantity1     = {label : 'Retour Endommagé Accepté',  writeOnly : false, readOnly : true, hidden : false,   background :'#faeeee'};
 qcAssignedReturnedDamagedQuantity2     = {label : 'Retour Périmé Accepté',     writeOnly : false, readOnly : true, hidden : false,   background :'#f0dede'};

 qcToBeAssignedReturnedQuantity         = {label : 'Retour A Valider',          writeOnly : true, readOnly : false,                   background :'#eef5fb'};
 qcToBeAssignedReturnedDamagedQuantity1 = {label : 'Retour Endomamgé A Valider',writeOnly : true, readOnly : false,                   background :'#faeeee'};
 qcToBeAssignedReturnedDamagedQuantity2 = {label : 'Retour Périmé A Valider',   writeOnly : true, readOnly : false,                   background :'#f0dede'};

 
  qColumns  = [];

  constructor(
    public    masterDataService : MasterDataService,
    protected warehouseService  : WarehouseService,
    protected toastr            : ToastrService,
    protected baseService       : BaseService,
    public    userService       : UserService,
    protected configService     : ConfigService,
    protected salesReportsService : SalesReportsService,
    protected leanUtilsService  : LeanUtilsService) {
    super(toastr, leanUtilsService);
  }
 
  
 //--------------------------------------------------------------------------------------------------------
  ngAfterViewInit() {
    super.ngAfterViewInit();

   //-------------------------------------------------------------------
   this.entryMode    = this.warehouseTransfer.edit;
  //-------------------------------------------------------------------

  //-------------------------------------------------------------------
      this.baseService.fieldsGet('warehouseTransfer').then(result => {
        if (result.listFields.length > 0) {
          this.columns = result.formFields;
        }
        this.columns.forEach(field => {
              this.enrichField(field);
        })
      })
  //-------------------------------------------------------------------


      this.setColumns();

  }

  setColumns(){
    this.qColumns  = [];
    
    if ( ! this.warehouseTransfer.returnWt) {
      this.qColumns  = [
        this.qcRequestedQuantity, 
        this.qcConfirmedQuantity,
        this.qcAssignedQuantity,
        this.qcAvailableQuantity
      ];

      if (this.warehouseTransfer.progressLevel == 10) {
        this.qColumns.push(this.qcToBeAssignedQuantity );
       // this.qColumns.push(this.qcToBeAssignedDamagedQuantity );
        this.qcConfirmedQuantity.readOnly = true;
      }

    } else {
      this.qColumns  = [
        this.qcConfirmedReturnedQuantity        ,  
        this.qcConfirmedReturnedDamagedQuantity1,  
        this.qcConfirmedReturnedDamagedQuantity2,  
        
        this.qcAssignedReturnedQuantity         ,  
        this.qcAssignedReturnedDamagedQuantity1 ,  
        this.qcAssignedReturnedDamagedQuantity2 ,  
      ];

      if (this.warehouseTransfer.progressLevel == 10) {
        this.qColumns.push(this.qcToBeAssignedReturnedQuantity);
        this.qColumns.push(this.qcToBeAssignedReturnedDamagedQuantity1);
        this.qColumns.push(this.qcToBeAssignedReturnedDamagedQuantity2);  
        
        this.qcAssignedReturnedQuantity.hidden          = true;  
        this.qcAssignedReturnedDamagedQuantity1.hidden  = true;  
        this.qcAssignedReturnedDamagedQuantity2.hidden  = true;  

        this.qcConfirmedReturnedQuantity.readOnly         = true;  
        this.qcConfirmedReturnedDamagedQuantity1.readOnly = true;
        this.qcConfirmedReturnedDamagedQuantity2.readOnly = true;
      }
    }

    if (this.warehouseTransfer.progressLevel == 10) {
      this.enteredOnly  = true;
      this.entryMode    = true;
    }
  }

  enrichField(field : Field){
    if (field.prop == 'progressLevel') {    
        field.pipe = this.warehouseTransferPipe;
    }

    if (field.prop == 'requestedForRole') {    
      field.modal = RoleLovComponent;
      field.subProp = 'name';
    }
  }
 //--------------------------------------------------------------------------------------------------------
  

 //--------------------------------------------------------------------------------------------------------
 setEntity(warehouseTransfer: WarehouseTransfer) {
    if (warehouseTransfer.inserted) {
      this.entryMode = true;
      this.enteredOnly = false;
    } 
    this.init(warehouseTransfer);
  }
 //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.warehouseTransfer;
  }
  //--------------------------------------------------------------------------------------------------------


  //--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<WarehouseTransfer>{

    if (! this.warehouseTransfer.requestedForRole.roleCode) {
      this.leanUtilsService.error("Prière de précisier le destinatire !");
        return null;
    }

    this.enteredOnly = true;

    let newwarehouseTransferRequests : WarehouseTransferRequest[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        let found : boolean = false;
        for (let warehouseTransferRequest of this.warehouseTransfer.warehouseTransferRequests) {
          if (product.productCode == warehouseTransferRequest.product.productCode) {
            found = true;
            if ( (! product.quantityL[0]) &&  (! product.quantityP[0]) && (! product.quantityU[0]) && (! product.quantityL[1]) &&  (! product.quantityP[1]) && (! product.quantityU[1]) && (! product.quantityL[2]) &&  (! product.quantityP[2]) && (! product.quantityU[2])) {
              warehouseTransferRequest.deleted = true;
            } else {
              if ( ! this.warehouseTransfer.returnWt) {
                warehouseTransferRequest.confirmedQuantity                  = this.getQuantity(product, 1);
              } else { 
                warehouseTransferRequest.confirmedReturnedQuantity          = this.getQuantity(product, 0); 
                warehouseTransferRequest.confirmedReturnedDamagedQuantity1  = this.getQuantity(product, 1); 
                warehouseTransferRequest.confirmedReturnedDamagedQuantity2  = this.getQuantity(product, 2); 
              }
            }
            break;
          }
        }
        if ( (! found) && 
                          ( product.quantityL[0] || product.quantityP[0] || product.quantityU[0] ||   product.quantityL[1] || product.quantityP[1] || product.quantityU[1] ||   product.quantityL[2] || product.quantityP[2] || product.quantityU[2] ) ) {
          let newWarehouseTransferRequest : WarehouseTransferRequest = 
          new WarehouseTransferRequest();
           newWarehouseTransferRequest.inserted            = true;
           newWarehouseTransferRequest.product             = new Product();
           newWarehouseTransferRequest.product.productCode = product.productCode;

           if ( ! this.warehouseTransfer.returnWt) {
            newWarehouseTransferRequest.confirmedQuantity                  = this.getQuantity(product, 1); 
          } else {
            newWarehouseTransferRequest.confirmedReturnedQuantity          = this.getQuantity(product, 0); 
            newWarehouseTransferRequest.confirmedReturnedDamagedQuantity1  = this.getQuantity(product, 1); 
            newWarehouseTransferRequest.confirmedReturnedDamagedQuantity2  = this.getQuantity(product, 2); 
          }
            
           newwarehouseTransferRequests.push(newWarehouseTransferRequest);
        }
      }
    }

    for (let warehouseTransferRequest of newwarehouseTransferRequests){
      this.warehouseTransfer.warehouseTransferRequests.push(warehouseTransferRequest);
    }

    if ( (! this.warehouseTransfer.warehouseTransferRequests) || (this.warehouseTransfer.warehouseTransferRequests.length == 0)) {
      this.leanUtilsService.error("Aucune quantité saisie sur aucun produit");
      return null;
    }
    return this.warehouseService.warehouseTransferSave(this.warehouseTransfer);
  }
  //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  afterValidate(){
    this.setColumns();
  }
  //--------------------------------------------------------------------------------------------------------
  

  cancel() {

    // Create cancelation
    if (this.warehouseTransfer.inserted){
      this.close();
      return;
    } 

    // Update cancelation
    this.warehouseService.warehouseTransferGet(this.warehouseTransfer.warehouseTransferCode).then(res => {
        this.warehouseTransfer = res; 
        return;
    })

  }

  
//----------------------------------------------------------------------
confirm(){
  this.entryMode = true;
  this.warehouseTransfer.warehouseTransferRequests.forEach(wtr => {
    if (! wtr.confirmedQuantity)  wtr.confirmedQuantity = wtr.requestedQuantity;
  });
  this.init(this.warehouseTransfer);
}

cancelWarehouseTransfer(){
    this.warehouseService.warehouseTransferCancel(this.warehouseTransfer.warehouseTransferCode).then(res => {
      this.warehouseTransfer = res; 
      return;
  })
}



confirmValidation(){
  this.saveRow().then(result => {
    this.setEntity(result);
    this.modifiedData     = true;
    this.entryMode = false;
    this.showSuccessFulOperation();
  }); 
}

notNull(n : number) : boolean {
  if (n == null) return false;
  if (n == undefined) return false;
  if (n == 0) return false;
  return true;
}

assignValidation(){
  //------------------------------------------------------------
  this.warehouseTransfer.warehouseTransferLines = [];
  for (let pp of this.masterDataService.salableProductPages) {
    for (let product of pp.products) {
      let relevantLine : boolean = false; 

      if (! this.warehouseTransfer.returnWt) {
        relevantLine =  this.notNull(product.quantityL[4]) || this.notNull(product.quantityP[4]) || this.notNull(product.quantityU[4]);
      } else {
        relevantLine =       this.notNull(product.quantityL[6]) || this.notNull(product.quantityL[7]) || this.notNull(product.quantityL[8])
                          || this.notNull(product.quantityP[6]) || this.notNull(product.quantityP[7]) || this.notNull(product.quantityP[8])
                          || this.notNull(product.quantityU[6]) || this.notNull(product.quantityU[7]) || this.notNull(product.quantityU[8]) ;
      }

      if (relevantLine) {
        let warehouseTransferLine : WarehouseTransferLine = new WarehouseTransferLine();
        if (! this.warehouseTransfer.returnWt) {
          warehouseTransferLine.quantity = this.getQuantity(product, 4);
         } else {
          warehouseTransferLine.returnedQuantity         = this.getQuantity(product, 6);
          warehouseTransferLine.returnedDamagedQuantity1 = this.getQuantity(product, 7);
          warehouseTransferLine.returnedDamagedQuantity2 = this.getQuantity(product, 8); 
        }

        warehouseTransferLine.product = new Product();
        warehouseTransferLine.product.productCode = product.productCode;
        warehouseTransferLine.productBatchCode = "?"
        this.warehouseTransfer.warehouseTransferLines.push(warehouseTransferLine);
      }
    }
  }
  //------------------------------------------------------------

  if ( (! this.warehouseTransfer.warehouseTransferLines) || (this.warehouseTransfer.warehouseTransferLines.length == 0)) {
    this.leanUtilsService.error("Aucune quantité validée sur aucun produit");
    return null;
  }

  this.warehouseService.warehouseTransferAssign(this.warehouseTransfer).then(result => {
    this.setEntity(result);
    this.modifiedData = true;
    this.entryMode    = false;
    this.showSuccessFulOperation();
  }); 
}

release(){
  this.warehouseService.warehouseTransferRelease(this.warehouseTransfer.warehouseTransferCode).then(result => {
    this.setEntity(result);
    this.showSuccessFulOperation();
  }); 
}

//----------------------------------------------------------------------
  
//----------------------------------------------------------------------
  balance(){
    this.warehouseService.warehouseTransferGet(this.warehouseTransfer.warehouseTransferCode, true).then(warehouseTransfer => {
      this.init(warehouseTransfer);
    })
  }
//----------------------------------------------------------------------




//----------------------------------------------------------------------
getLine(sdeliveryNote : SdeliveryNote, product : Product,  freeGoodLine : boolean) : SdeliveryNoteLine{
  let sdnl : SdeliveryNoteLine =  sdeliveryNote.sdeliveryNoteLines.find(tmp => (tmp.product.productCode == product.productCode) && (tmp.freeGoodLine == freeGoodLine) );
  if (!sdnl) sdnl = new SdeliveryNoteLine();
  return sdnl;  
}

updatable(sdeliveryNote : SdeliveryNote, product : Product) : boolean {
  let line = this.getLine(sdeliveryNote , product,  false) ;
  if (! line) return false;

  return (line.orderedQuantity != null) && (line.orderedQuantity != 0);
}

isFreeGood(sdeliveryNote : SdeliveryNote, product : Product) : boolean {
  let result : boolean = false;
  let line =  this.getLine(sdeliveryNote, product, true);

  if (! line) return false;
   return (line.quantity > 0);
}



//----------------------------------------------------------------------
getRequiredQuantity(wtr : WarehouseTransferRequest) : number{
  let result : number = 0;
  let productCode : string = wtr.product.productCode;

  this.warehouseTransfer.sdeliveryNotes.forEach(sdn => {
    sdn.sdeliveryNoteLines.forEach(sdnl => {
      if (sdnl.product.productCode == productCode) {
        result += sdnl.quantity;
      }
    });
  });

  wtr.balanced = (wtr.assignedQuantity + wtr.availableQuantity >= result);

  return result;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  showValidate() : boolean {
    let atLeastOnUnBalanced = false;
    for (let wtr of this.warehouseTransfer.warehouseTransferRequests){
      if (! wtr.initialyBalanced) {
        atLeastOnUnBalanced = true;
        break;
      }
    }

    let allAreBalanced = true;
    for (let wtr of this.warehouseTransfer.warehouseTransferRequests){
      if (! wtr.balanced) {
        allAreBalanced = false;
        break;
      }
    }
    return (allAreBalanced && atLeastOnUnBalanced);
  }
//----------------------------------------------------------------------
  
//----------------------------------------------------------------------
  warehouseTransferSdeliveryNotesUpdate(){
    this.warehouseService.warehouseTransferSdeliveryNotesUpdate(this.warehouseTransfer).then(warehouseTransfer => {
      this.init(warehouseTransfer);
    } )
  }
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------

init(warehouseTransfer: WarehouseTransfer){

  this.masterDataService.loadProductPages(4, true).then(res => {

    if (warehouseTransfer.warehouseTransferRequests) {
      for (let warehouseTransferRequest of warehouseTransfer.warehouseTransferRequests) {
        for (let pp of this.masterDataService.salableProductPages) {
          for (let product of pp.products) {
            if (product.productCode == warehouseTransferRequest.product.productCode) {

              if (this.purchasePacking) {
                  this.setProductQuantitiesWithPurchasePacking(product, warehouseTransferRequest);
              } else {
                this.setProductQuantitiesWithoutPurchasePacking(product, warehouseTransferRequest);
              }        
              pp.expand = true;
              break;
            }
          }
        }
      }
    }
  })

  if ( warehouseTransfer.warehouseTransferRequests) {
      warehouseTransfer.warehouseTransferRequests.forEach(wtr => {wtr.initialyBalanced = wtr.balanced})
  }


  //-------------------------------------------------
  if ( warehouseTransfer.sdeliveryNotes) {
    warehouseTransfer.sdeliveryNotes.forEach(sdn => {
      if ( sdn.sdeliveryNoteLines) {
          sdn.sdeliveryNoteLines.forEach(sdnl => {
            sdnl.orderedQuantity = sdnl.quantity;
          });
      }
    });
  }

  this.warehouseTransfer  = warehouseTransfer;

  /*
  this.warehouseTransfer  = { ...warehouseTransfer };

  this.warehouseTransfer.sdeliveryNotes = [];
  if (warehouseTransfer.sdeliveryNotes) {
    for (let sdeliveryNote of warehouseTransfer.sdeliveryNotes) {
      this.warehouseTransfer.sdeliveryNotes.push({ ...sdeliveryNote });
    }
  }
  
  this.warehouseTransfer.warehouseTransferRequests = [];
  if (warehouseTransfer.warehouseTransferRequests) {
    for (let warehouseTransferRequest of warehouseTransfer.warehouseTransferRequests) {
      this.warehouseTransfer.warehouseTransferRequests.push({ ...warehouseTransferRequest });
    }
  }

  this.warehouseTransfer.warehouseTransferLines = [];
  if (warehouseTransfer.warehouseTransferLines) {
    for (let warehouseTransferLine of warehouseTransfer.warehouseTransferLines) {
      this.warehouseTransfer.warehouseTransferLines.push({ ...warehouseTransferLine });
    }
  }
*/
}
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  setProductQuantitiesWithPurchasePacking(product : Product, warehouseTransferRequest : WarehouseTransferRequest) {
    if (! this.warehouseTransfer.returnWt) {
      product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.requestedQuantity / product.purchasePacking));
      product.quantityL[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedQuantity / product.purchasePacking));
      product.quantityL[2] = this.leanUtilsService.zeroToNull( Math.floor(warehouseTransferRequest.assignedQuantity / product.purchasePacking));
      product.quantityL[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.availableQuantity / product.purchasePacking));
      product.quantityL[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity1 / product.purchasePacking));

      product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.requestedQuantity % product.purchasePacking) / product.loadPacking));
      product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.confirmedQuantity % product.purchasePacking) / product.loadPacking));
      product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.assignedQuantity  % product.purchasePacking) / product.loadPacking));
      product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.availableQuantity % product.purchasePacking) / product.loadPacking));
      product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.movedQuantity1    % product.purchasePacking) / product.loadPacking));

      product.quantityU[0] = this.leanUtilsService.round(warehouseTransferRequest.requestedQuantity  -  (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[1] = this.leanUtilsService.round(warehouseTransferRequest.confirmedQuantity  -  (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[2] = this.leanUtilsService.round(warehouseTransferRequest.assignedQuantity   -  (this.leanUtilsService.nullToZero(product.quantityL[2]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[3] = this.leanUtilsService.round(warehouseTransferRequest.availableQuantity  -  (this.leanUtilsService.nullToZero(product.quantityL[3]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[4] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity1     -  (this.leanUtilsService.nullToZero(product.quantityL[4]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking), product.decimalPrecision);


    } else {

      product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedQuantity / product.purchasePacking));
      product.quantityL[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedDamagedQuantity1 / product.purchasePacking));
      product.quantityL[2] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedDamagedQuantity2 / product.purchasePacking));

      product.quantityL[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedQuantity / product.purchasePacking));
      product.quantityL[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedDamagedQuantity1 / product.purchasePacking));
      product.quantityL[5] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedDamagedQuantity2 / product.purchasePacking));

      product.quantityL[6] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity2 / product.purchasePacking));
      product.quantityL[7] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity3 / product.purchasePacking));
      product.quantityL[8] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity4 / product.purchasePacking));


      product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.confirmedReturnedQuantity % product.purchasePacking)         / product.loadPacking));
      product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.confirmedReturnedDamagedQuantity1 % product.purchasePacking) / product.loadPacking));
      product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.confirmedReturnedDamagedQuantity2 % product.purchasePacking) / product.loadPacking));

      product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.assignedReturnedQuantity % product.purchasePacking)         / product.loadPacking));
      product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.assignedReturnedDamagedQuantity1 % product.purchasePacking) / product.loadPacking));
      product.quantityP[5] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.assignedReturnedDamagedQuantity2 % product.purchasePacking) / product.loadPacking));

      product.quantityP[6] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.movedQuantity2 % product.purchasePacking) / product.loadPacking));
      product.quantityP[7] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.movedQuantity3 % product.purchasePacking) / product.loadPacking));
      product.quantityP[8] = this.leanUtilsService.zeroToNull(Math.floor((warehouseTransferRequest.movedQuantity4 % product.purchasePacking) / product.loadPacking));


      product.quantityU[0] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedQuantity         - (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[1] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedDamagedQuantity1 - (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[2] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedDamagedQuantity2 - (this.leanUtilsService.nullToZero(product.quantityL[2]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking), product.decimalPrecision);
      
      product.quantityU[3] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedQuantity         - (this.leanUtilsService.nullToZero(product.quantityL[3]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[4] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedDamagedQuantity1 - (this.leanUtilsService.nullToZero(product.quantityL[4]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[5] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedDamagedQuantity2 - (this.leanUtilsService.nullToZero(product.quantityL[5]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[5]) * product.loadPacking), product.decimalPrecision);
      
      product.quantityU[6] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity2                   - (this.leanUtilsService.nullToZero(product.quantityL[6]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[6]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[7] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity3                   - (this.leanUtilsService.nullToZero(product.quantityL[7]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[7]) * product.loadPacking), product.decimalPrecision);
      product.quantityU[8] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity4                   - (this.leanUtilsService.nullToZero(product.quantityL[8]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[8]) * product.loadPacking), product.decimalPrecision);

    }
  }

  setProductQuantitiesWithoutPurchasePacking(product : Product, warehouseTransferRequest : WarehouseTransferRequest) {

    if (! this.warehouseTransfer.returnWt) {

      product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.requestedQuantity / product.loadPacking));
      product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedQuantity / product.loadPacking));
      product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedQuantity  / product.loadPacking));
      product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.availableQuantity / product.loadPacking));
      product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity1    / product.loadPacking));

      product.quantityU[0] = this.leanUtilsService.zeroToNull(warehouseTransferRequest.requestedQuantity % product.loadPacking);
      product.quantityU[1] = this.leanUtilsService.zeroToNull(warehouseTransferRequest.confirmedQuantity % product.loadPacking);
      product.quantityU[2] = this.leanUtilsService.zeroToNull(warehouseTransferRequest.assignedQuantity  % product.loadPacking);
      product.quantityU[3] = this.leanUtilsService.zeroToNull(warehouseTransferRequest.availableQuantity % product.loadPacking);
      product.quantityU[4] = this.leanUtilsService.zeroToNull(warehouseTransferRequest.movedQuantity1    % product.loadPacking);

    } else {

      product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedQuantity         / product.loadPacking));
      product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedDamagedQuantity1 / product.loadPacking));
      product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.confirmedReturnedDamagedQuantity2 / product.loadPacking));

      product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedQuantity          / product.loadPacking));
      product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedDamagedQuantity1  / product.loadPacking));
      product.quantityP[5] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.assignedReturnedDamagedQuantity2  / product.loadPacking));

      product.quantityP[6] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity2                    / product.loadPacking));
      product.quantityP[7] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity3                    / product.loadPacking));
      product.quantityP[8] = this.leanUtilsService.zeroToNull(Math.floor(warehouseTransferRequest.movedQuantity4                    / product.loadPacking));


      product.quantityU[0] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedQuantity          %  product.loadPacking, product.decimalPrecision);
      product.quantityU[1] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedDamagedQuantity1  %  product.loadPacking, product.decimalPrecision);
      product.quantityU[2] = this.leanUtilsService.round(warehouseTransferRequest.confirmedReturnedDamagedQuantity2  %  product.loadPacking, product.decimalPrecision);

      product.quantityU[3] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedQuantity           %  product.loadPacking, product.decimalPrecision);
      product.quantityU[4] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedDamagedQuantity1   %  product.loadPacking, product.decimalPrecision);
      product.quantityU[5] = this.leanUtilsService.round(warehouseTransferRequest.assignedReturnedDamagedQuantity2   %  product.loadPacking, product.decimalPrecision);

      product.quantityU[6] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity2                     %  product.loadPacking, product.decimalPrecision);
      product.quantityU[7] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity3                     %  product.loadPacking, product.decimalPrecision);
      product.quantityU[8] = this.leanUtilsService.round(warehouseTransferRequest.movedQuantity4                     %  product.loadPacking, product.decimalPrecision);

    }
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  assignFifo(){    
    for (let wtr of this.warehouseTransfer.warehouseTransferRequests) {
      if (wtr.initialyBalanced) continue;
      let product = wtr.product;
      let availableQuantity = wtr.assignedQuantity + wtr.availableQuantity;
      for (let sdeliveryNote of this.warehouseTransfer.sdeliveryNotes) {
        if (sdeliveryNote.balanced) continue;
        
        let sdnl : SdeliveryNoteLine =  sdeliveryNote.sdeliveryNoteLines.find(tmp => (tmp.product.productCode == product.productCode) && (! tmp.freeGoodLine) );
        if (! sdnl) continue;

        if (availableQuantity == 0) {  
          sdnl.quantity = 0;
          continue;
        }

        if (sdnl.orderedQuantity <= availableQuantity) {
          sdnl.quantity = sdnl.orderedQuantity;
          availableQuantity = availableQuantity -  sdnl.orderedQuantity;
        } else {
          sdnl.quantity = availableQuantity;
          availableQuantity = 0;
        }
      }
    }
  }
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
assignProrata(){    
  for (let wtr of this.warehouseTransfer.warehouseTransferRequests) {
    if (wtr.initialyBalanced) continue;
    let rate =(wtr.assignedQuantity + wtr.availableQuantity) / wtr.confirmedQuantity;
    let product = wtr.product;

    for (let sdeliveryNote of this.warehouseTransfer.sdeliveryNotes) {
      if (sdeliveryNote.balanced) continue;
      
      let sdnl : SdeliveryNoteLine =  sdeliveryNote.sdeliveryNoteLines.find(tmp => (tmp.product.productCode == product.productCode) && (! tmp.freeGoodLine) );
      if (! sdnl) continue;

      let qty = sdnl.orderedQuantity * rate;
      sdnl.quantity = Math.round(qty);
    }
  }
}
//---------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------------------
  getQuantity(product: Product, index: number): number {
    let res = (this.leanUtilsService.nullToZero(product.quantityL[index]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[index]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[index]);
    return res;
  }
  //------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------

 

//---------------------------------------------------------------------------------------
print(){
  this.salesReportsService.warehouseTransferPrint(this.warehouseTransfer.warehouseTransferCode);
}
//---------------------------------------------------------------------------------------

}


